module.exports = __webpack_public_path__ + "static/media/h8_give_bw.bb3d5bf5.webp";